import { FETCH_ACCESS_FAILURE, FETCH_ACCESS_SUCCESS } from '@/Types/accessTypes';
import {
  FETCH_ACCESS_PROFILE_FAILURE,
  FETCH_ACCESS_PROFILE_LOADING,
  FETCH_ACCESS_PROFILE_SUCCESS,
  ADD_ACCESS_PROFILE_FAILURE,
  ADD_ACCESS_PROFILE_SUCCESS,
  ADD_ACCESS_PROFILE_LOADING,
  UPDATE_ACCESS_PROFILE_FAILURE,
  UPDATE_ACCESS_PROFILE_LOADING,
  UPDATE_ACCESS_PROFILE_SUCCESS,
  DELETE_ACCESS_PROFILE_FAILURE,
  DELETE_ACCESS_PROFILE_LOADING,
  DELETE_ACCESS_PROFILE_SUCCESS,
  FETCH_GROUP_ACCESS_SUCCESS,
  FETCH_GROUP_ACCESS_FAILURE,
  ADD_GROUP_WITH_PRIORITY_FAILURE,
  ADD_GROUP_WITH_PRIORITY_SUCCESS,
  ADD_GROUP_WITH_PRIORITY_LOADING,
  UPDATE_GROUP_ZONE_PRIORITIES_SUCCESS,
  UPDATE_GROUP_ZONE_PRIORITIES_LOADING,
  UPDATE_GROUP_ZONE_PRIORITIES_FAILURE,
  FETCH_GROUPS_BY_ZONE_PRIORITY_LOADING,
  FETCH_GROUPS_BY_ZONE_PRIORITY_SUCCESS,
  FETCH_GROUPS_BY_ZONE_PRIORITY_FAILURE,
  CLEAR_GROUP_ACCESS
} from '../Types/accessProfileTypes';
import api from '../config/api';

const API_WP = process.env.REACT_APP_API_URL;
export const getAccessProfiles = () => {
  return dispatch => {
    dispatch({
      type: FETCH_ACCESS_PROFILE_LOADING
    });
    api
      .get(`${API_WP}Group/`)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_ACCESS_PROFILE_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_ACCESS_PROFILE_FAILURE,
          payload: errorMsg
        });
      });
  };
};

export const getAccessProfileById = id => {
  return dispatch => {
    dispatch({
      type: FETCH_ACCESS_PROFILE_LOADING
    });
    api
      .get(`${API_WP}Group/search/${id}`)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_ACCESS_PROFILE_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_ACCESS_PROFILE_FAILURE,
          payload: errorMsg
        });
      });
  };
};
export const addAccessProfile = data => {
  return async dispatch => {
    dispatch({ type: ADD_ACCESS_PROFILE_LOADING });
    try {
      const response = await api.post(`${API_WP}Group/add`, data);

      await dispatch(getAccessProfiles());

      dispatch({
        type: ADD_ACCESS_PROFILE_SUCCESS,
        payload: response.data.data
      });
    } catch (error) {
      dispatch({
        type: ADD_ACCESS_PROFILE_FAILURE,
        payload: error.message
      });
    }
  };
};
export const updateAccessProfile = (id, profile) => {
  return dispatch => {
    dispatch({ type: UPDATE_ACCESS_PROFILE_LOADING });
    api
      .put(`${API_WP}Group/update/${id}`, { data: profile })
      .then(response => {
        dispatch({
          type: UPDATE_ACCESS_PROFILE_SUCCESS,
          payload: response.data.data
        });

        dispatch(getAccessProfiles());
      })
      .catch(error => {
        dispatch({
          type: UPDATE_ACCESS_PROFILE_FAILURE,
          payload: error.message
        });
      });
  };
};
export const removeAccessProfile = id => {
  return dispatch => {
    dispatch({ type: DELETE_ACCESS_PROFILE_LOADING });
    api
      .delete(`${API_WP}Group/remove/${id}`)
      .then(() => {
        dispatch({
          type: DELETE_ACCESS_PROFILE_SUCCESS,
          payload: id
        });
      })
      .catch(error => {
        dispatch({
          type: DELETE_ACCESS_PROFILE_FAILURE,
          payload: error.message
        });
      });
  };
};

export const getGroupAccesses = id => {
  return async dispatch => {
    dispatch({ type: CLEAR_GROUP_ACCESS });
    dispatch({ type: FETCH_ACCESS_PROFILE_LOADING });
    
    try {
      const response = await api.get(`${API_WP}Group/getGroupAccess/${id}`);
      
      if (!response.data.data || response.data.data.length === 0) {
        dispatch(clearGroupAccess());
      } else {
        dispatch({
          type: FETCH_GROUP_ACCESS_SUCCESS,
          payload: response.data.data
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_GROUP_ACCESS_FAILURE,
        payload: error.message
      });
    }
  };
};

export const addGroupWithPriority = data => {
  return async dispatch => {
    dispatch({ type: ADD_GROUP_WITH_PRIORITY_LOADING });
    try {
      const response = await api.post(`${API_WP}Group/addGroupWithPriority`, data);

      dispatch({
        type: ADD_GROUP_WITH_PRIORITY_SUCCESS,
        payload: {
          group: response.data.data.group,
          zonePriorities: response.data.data.zonePriorities
        }
      });

      await dispatch(getGroupsWithZonePriorities());

      return {
        type: ADD_GROUP_WITH_PRIORITY_SUCCESS,
        payload: response.data.data
      };
    } catch (error) {
      dispatch({
        type: ADD_GROUP_WITH_PRIORITY_FAILURE,
        payload: error.message
      });
      throw error;
    }
  };
};

export const updateGroupZonePriorities = (groupId, prioritiesData) => {
  return async dispatch => {
    dispatch({ type: UPDATE_GROUP_ZONE_PRIORITIES_LOADING });
    try {
      const response = await api.put(`${API_WP}Group/updateGroupAccessPriority/${groupId}`, prioritiesData);
      
      dispatch({
        type: UPDATE_GROUP_ZONE_PRIORITIES_SUCCESS,
        payload: response.data.data
      });

      await dispatch(getGroupsWithZonePriorities());
    } catch (error) {
      dispatch({
        type: UPDATE_GROUP_ZONE_PRIORITIES_FAILURE,
        payload: error.message
      });
    }
  };
};

export const getGroupsWithZonePriorities = () => {
  return async dispatch => {
    dispatch({ type: FETCH_GROUPS_BY_ZONE_PRIORITY_LOADING });

    try {
      const response = await api.get(`${API_WP}Group/withZonePriorities`);
      
      dispatch({
        type: FETCH_GROUPS_BY_ZONE_PRIORITY_SUCCESS,
        payload: response.data.data
      });
      
      return response.data.data;
    } catch (error) {
      dispatch({
        type: FETCH_GROUPS_BY_ZONE_PRIORITY_FAILURE,
        payload: error.message
      });
      throw error;
    }
  };
};
export const clearGroupAccess = () => ({
  type: CLEAR_GROUP_ACCESS
});